import { fg } from '@atlaskit/platform-feature-flags';

export function createAtlAttributionHeader({
	atlWorkspaceId,
	tenantId,
	product = 'platform',
}: {
	atlWorkspaceId?: string;
	tenantId: string;
	product?: string;
}) {
	if (!fg('psd_agg_atl_attribution_header')) {
		return;
	}

	const atlAttributionHeader = {
		...(atlWorkspaceId ? { atlWorkspaceId } : {}),
		tenantId,
		product,
	};
	return { 'atl-attribution': JSON.stringify(atlAttributionHeader) };
}
